<mat-toolbar color="primary" class="navbar">
    <span color="primary" (click)="opened = !opened">
        <mat-icon>menu</mat-icon>
    </span>
    &nbsp; &nbsp;  
    <a routerLink="/">
        <span>Home</span>
    </a>

    <span class="fill-remaining-space"></span>
    
</mat-toolbar>
<mat-sidenav-container>
    <mat-sidenav #sideNav [(opened)]="opened" mode="side">
        <mat-nav-list>
            <a mat-list-item routerLink="notas">
                <mat-icon>book</mat-icon>Nueva Nota
            </a>
        </mat-nav-list>

        <mat-divider></mat-divider>


        <mat-nav-list>
            <a mat-list-item routerLink="imagen">
                <mat-icon>camera_enhance</mat-icon>Imagen Nueva
            </a>
        </mat-nav-list>

        <mat-divider></mat-divider>

        <mat-nav-list>
            <a mat-list-item routerLink="dibujo">
                <mat-icon>insert_photo</mat-icon>Dibujo Nuevo
            </a>
        </mat-nav-list>

        <mat-divider></mat-divider>

        <mat-nav-list>
            <a mat-list-item routerLink="libro">
                <mat-icon>book</mat-icon>Libro Nuevo
            </a>
        </mat-nav-list>

        <mat-divider></mat-divider>

        <mat-nav-list>
            <a mat-list-item routerLink="profile">
                <mat-icon>account_circle</mat-icon>Usuarios
            </a>
        </mat-nav-list>

        <mat-divider></mat-divider>

        <mat-nav-list>
            <a mat-list-item routerLink="auditorias">
                <mat-icon>assessment</mat-icon>Auditorias
            </a>
        </mat-nav-list>

    </mat-sidenav>
    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>